module.exports = __webpack_public_path__ + "static/media/Ileum.15b39fe2.ogg";